export default __webpack_public_path__ + "static/media/Apple_Chancery_100.672cdecc.ttf";